// extracted by mini-css-extract-plugin
module.exports = {"headerStyle":"components_headerStyle__0_5Qd","subHeadingStyle":"components_subHeadingStyle__XmMAH"};